export const ChatTypingIndicator = () => {
    return (
        <div className="tw-flex tw-justify-start">
            <div className="tw-bg-white tw-shadow-sm tw-border tw-border-gray-100 tw-rounded-2xl tw-rounded-bl-sm tw-px-4 tw-py-3">
                <div className="tw-flex tw-gap-1 tw-items-center">
                    <span className="tw-w-1.5 tw-h-1.5 tw-bg-gray-400 tw-rounded-full chat-typing-dot" style={{ animationDelay: '0ms' }} />
                    <span className="tw-w-1.5 tw-h-1.5 tw-bg-gray-400 tw-rounded-full chat-typing-dot" style={{ animationDelay: '150ms' }} />
                    <span className="tw-w-1.5 tw-h-1.5 tw-bg-gray-400 tw-rounded-full chat-typing-dot" style={{ animationDelay: '300ms' }} />
                </div>
            </div>
        </div>
    );
};

export default ChatTypingIndicator;
